import useSingleSampleSelect from 'components/samples/components/SingleSampleSelection/shared/hooks/useSingleSampleSelect';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import { AddSample } from 'autogen/translation-keys/trans-website-basket-samples-singlesample';
import { useTranslation } from 'react-i18next';
import toast from 'components/Toast';
import { SampleDecline } from 'autogen/translation-keys/trans-website-basket-samples';
import { GoToCheckout } from 'autogen/translation-keys/trans-website-basket';
import { breakpoint, sizes } from 'variables';
import styled from 'styled-components';
import format from 'helpers/translations';
import type { MessageWithQueueCallbacks } from 'components/pages/Basket/components/BasketCheckoutActions/BasketCheckoutButton/BasketCheckoutMessagesButton';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import useIsAuthenticated from 'hooks/user/useIsAuthenticated';
import { AddedToBasket } from 'autogen/translation-keys/trans-website-myprofile-samples-likedsample';
import Icon from 'components/Icon';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: ${Spacing24};
    gap: ${Spacing16};
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${Spacing16};

    & > button {
        flex: 1
    }

    ${breakpoint.up(sizes.sm)} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export default function SingleSampleMessage({ message }: { message: MessageWithQueueCallbacks }) {
    const { messageContent, isLastMessage, nextMessageInQueue, closeAndCancelQueue } = message;
    const { t } = useTranslation();
    const handleSingleSampleSelect = useSingleSampleSelect();
    const isAuthenticated = useIsAuthenticated();

    return (
        <Wrapper>
            <div>{format(messageContent)}</div>

            <ButtonWrapper>
                <ButtonWithSpinner
                    size="lg"
                    variant="secondary"
                    onClick={async () => {
                        await handleSingleSampleSelect();

                        if (!isAuthenticated) {
                            closeAndCancelQueue();
                        } else {
                            toast.success<string>(t(AddedToBasket), {
                                position: 'top-right'
                            });
                            nextMessageInQueue();
                        }
                    }}
                >
                    {t(AddSample)}
                </ButtonWithSpinner>
                <ButtonWithIcon
                    size="lg"
                    type="button"
                    onClick={() => nextMessageInQueue()}
                    icon={<Icon type="ChevronRight" size={16} />}
                    iconProperties={{ position: 'right' }}
                >
                    {!isLastMessage ? t(SampleDecline) : t(GoToCheckout)}
                </ButtonWithIcon>
            </ButtonWrapper>
        </Wrapper>
    );
}
